import Column from 'layout/Components/Column'
import { RowMiddle } from 'layout/Components/Row'
import React from 'react'
import { Trans } from 'react-i18next'
import styled, { css } from 'styled-components'
import { getIcon } from 'svgs'
import theme from 'theme'
import { FlexProps } from 'UIKit/Box/types'
import Text from 'UIKit/Text'
import { PaymentPageEnums } from 'views/Payment/Menu'

type PaymentMenuProps = FlexProps & {
  paymentPage: PaymentPageEnums
  onPaymentPageChanged: (value: PaymentPageEnums) => void
  colorTheme: string
}

const TabItem: React.FC<{
  isActive: boolean
  onClick: () => void
  icon: string
  title: string
}> = ({ isActive, onClick, title, icon }) => {
  const Icon = icon && getIcon(icon)

  return (
    <StyledTab $active={isActive} onClick={onClick}>
      {Icon && <Icon width="24px" />}
      <Text bold small>
        <Trans>{title}</Trans>
      </Text>
    </StyledTab>
  )
}

export const PaymentMenuDesktop: React.FC<PaymentMenuProps> = ({
  paymentPage,
  onPaymentPageChanged,
  colorTheme,
  ...props
}) => {
  // const { userSettings } = useUserSettings()
  // const isActive2FA = userSettings.isActive2FA

  return (
    <Column
      gap="12px"
      minWidth="200px"
      width="200px"
      height="100%"
      py="24px"
      px="12px"
      background={theme.modal.colors[colorTheme].modalCard}
      {...props}
    >
      <TabItem
        isActive={paymentPage === PaymentPageEnums.Deposit}
        onClick={() => onPaymentPageChanged(PaymentPageEnums.Deposit)}
        title="Deposit"
        icon="PaymentDepositIcon"
      />

      <TabItem
        isActive={paymentPage === PaymentPageEnums.Withdraw}
        onClick={() => onPaymentPageChanged(PaymentPageEnums.Withdraw)}
        title="Withdraw"
        icon="PaymentWithdrawalIcon"
      />

      <TabItem
        isActive={paymentPage === PaymentPageEnums.Swap}
        onClick={() => onPaymentPageChanged(PaymentPageEnums.Swap)}
        title="Swap"
        icon="PaymentSwapIcon"
      />

      <TabItem
        isActive={paymentPage === PaymentPageEnums.Tip}
        onClick={() => onPaymentPageChanged(PaymentPageEnums.Tip)}
        title="Tips"
        icon="PaymentTipIcon"
      />

      {/* <Box
        height="1px"
        width="100%"
        background="#54545699"
      /> */}

      {/* {!isActive2FA && <TwoFactorWarning />} */}
    </Column>
  )
}

const StyledTab = styled(RowMiddle)<{ $active: boolean }>`
  padding: 8px;
  gap: 8px;
  border-radius: 8px;
  cursor: pointer;
  transition: 0.2s;
  position: relative;
  color: var(--pm-label-color);

  ${Text}, svg {
    color: currentColor;
    transition: 0.2s;
  }

  &:hover {
    color: ${({ theme }) => theme.colors.text};
  }

  ${({ $active }) =>
    $active
      ? css`
          background: var(--pm-card-active-hover);
          color: ${({ theme }) => theme.colors.text};
        `
      : css``}
`
